import { Component } from '@angular/core';
import { ModalService } from '@common/services/ModalService/ModalService';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-modal-component',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  animations: [
    trigger('modalVisibility', [
      state('visible', style({
        opacity: 1,
        visibility: 'visible',
      })),
      state('invisible', style({
        opacity: 0,
        visibility: 'hidden',
      })),
      transition('visible <=> invisible', animate('100ms ease-in')),
    ]),
  ],
})
export class ModalComponent {
  constructor(
    public modalService: ModalService,
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/common/components/ModalComponent/modal.component.ts